import { Injectable } from '@angular/core';

import { AuthService } from '../services/auth.service';
import { RoleType } from '../utilities/constants';

@Injectable()
export class RoleGuard  {
    constructor(private _identityService: AuthService) { }

    canActivate() {
        let userRoleType = this._identityService.getRoleType();
        if (this._identityService.isLoggedIn()
            && (userRoleType == RoleType.MINDPLAY_EMPLOYEE)) {
            return true;
        }

        return false;
    }
}
